<div class="card m-0 shadow-none">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h5 class="m-0">Resident Snapshot</h5>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn p-2"
          (click)="modal.dismiss('Cross click')">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h6>Cognitive Signals Color</h6>
        <p>
          Select a Cognitive Signal Color before printing the resident snapshot
        </p>

        <select class="form-select" [formControl]="control">
          <option [value]="null">Select color...</option>
          <option value="green">Green</option>
          <option value="yellow">Yellow</option>
          <option value="red">Red</option>
        </select>
      </div>
      <div class="col-12 mt-2" *ngIf="error">
        <alert [dismissible]="false" type="danger">
          <i class="mdi mdi-alert-circle-outline me-2 font-size-18"></i>
          Select a Cognitive Signal Color
        </alert>
      </div>
    </div>
  </div>

  <div class="card-footer bg-transparent border-top">
    <div class="row justify-content-between">
      <div class="col-auto">
        <button
          (click)="modal.dismiss('Cross click')"
          type="button"
          class="btn btn-light-2">
          Cancel
        </button>
      </div>

      <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="download()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none">
            <path
              d="M11.6101 5.50851C11.5824 5.44521 11.5437 5.38734 11.4958 5.33759L7.99579 1.83759C7.94604 1.78966 7.88817 1.75094 7.82487 1.72326C7.80737 1.71509 7.78871 1.71042 7.77004 1.70401C7.72122 1.68746 7.67041 1.67745 7.61896 1.67426C7.60671 1.67309 7.59562 1.66667 7.58337 1.66667H3.50004C2.85662 1.66667 2.33337 2.18992 2.33337 2.83334V12.1667C2.33337 12.8101 2.85662 13.3333 3.50004 13.3333H10.5C11.1435 13.3333 11.6667 12.8101 11.6667 12.1667V5.75C11.6667 5.73775 11.6603 5.72667 11.6591 5.71384C11.6559 5.66238 11.6459 5.61158 11.6294 5.56275C11.6239 5.54409 11.6175 5.52601 11.6101 5.50851ZM9.67521 5.16667H8.16671V3.65817L9.67521 5.16667ZM3.50004 12.1667V2.83334H7.00004V5.75C7.00004 5.90471 7.0615 6.05309 7.1709 6.16248C7.28029 6.27188 7.42866 6.33334 7.58337 6.33334H10.5L10.5012 12.1667H3.50004Z"
              fill="white" />
            <path
              d="M4.66671 7.5H9.33337V8.66667H4.66671V7.5ZM4.66671 9.83334H9.33337V11H4.66671V9.83334ZM4.66671 5.16667H5.83337V6.33334H4.66671V5.16667Z"
              fill="white" />
          </svg>
          Download PDF
        </button>
      </div>
    </div>
  </div>
</div>
